// extracted by mini-css-extract-plugin
export default {"borderTop":"nW4DO","borderBottom":"s1f_k","action":"nrO67"};